<template>
  <div class="contents shinsei">
    <h2>各種申請</h2>

    <div class="container shinsei-menu page-menu-items">
      <div class="menu">
        <div class="col-item">
          <router-link :to="{ name: RouterConst.SHINSEI_LIST }">申請一覧</router-link>
          <p>各種申請の検索と一覧表示、詳細の確認ができます。</p>
        </div>

        <div class="col-item" v-if="authStore.hasPermission(PermissionConst.SHINSEI_CREATE)">
          <router-link :to="{ name: RouterConst.SHINSEI_TYPE_LIST }">新規作成</router-link>
          <p>各種申請の作成を行います。</p>
        </div>
      </div>
      <!-- menu -->
    </div>
    <!--container-->
  </div>
  <!--contents-->
</template>

<script lang="ts">
import { PermissionConst } from "@/const/Permission";
import { RouterConst } from "@/const/Router";
import { useAuthStore } from "@/store/auth";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const authStore = useAuthStore()
    return {
      PermissionConst,
      authStore,
      RouterConst
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@scss/_shinsei.scss";
@import "@scss/components/menu-items.scss";
</style>

